<script lang="ts" setup>
import type { DynamicAuctionItemList } from '@autobid/strapi-integration/rest/components'
import type { CarsListCar, SearchListCar } from '@autobid/ui/types/Car'
import { inject } from 'vue'

interface Props {
  car: CarsListCar | SearchListCar
  descActive: boolean
}

defineProps<Props>()

defineEmits(['toggleDesc'])

const auctionStrapiData = inject<DynamicAuctionItemList>('auction-strapi-data')
</script>

<template>
  <div
    class="flex w-full flex-col md:flex-row"
    :class="{
      'xl:w-[57%]': auctionStrapiData?.type === 'carList',
      'xl:w-[37%]': auctionStrapiData?.type === 'carSearch',
    }"
  >
    <div v-if="car.stage !== 'REMOVED'" class="w-full">
      <ElementsCarParameters
        class="pr-6 text-center md:flex-col md:pr-0 md:text-left lg:flex-row [@media(max-width:500px)]:[&>div]:flex-1 [@media(max-width:500px)]:[&>div]:justify-center"
        :car="car"
        power-in-two-lines
      />

      <div class="relative -right-2 -top-12 -mt-8 flex justify-end md:hidden">
        <button
          class="block h-10 w-10 text-4xl transition"
          :class="{
            'rotate-180': descActive,
          }"
          @click.stop="$emit('toggleDesc')"
        >
          <Icon mode="css" name="icon-park-outline:down" />
        </button>
      </div>
    </div>
  </div>
</template>
